import { Box } from "@mui/material";

import { withForm } from "components/Forms/AppForm";

import { defaultProficiencyFeedbackValues } from "../../../ProficiencyFeedbackForm.default";
import { PF_FORM_RATING_QUESTIONS } from "../data/PfRatings";

const RatingsForm = withForm({
  defaultValues: defaultProficiencyFeedbackValues,
  props: { readonly: false },
  render: ({ form, readonly }) => {
    return (
      <>
        {PF_FORM_RATING_QUESTIONS.map((question) => (
          <Box key={question.value} mt={3}>
            <form.AppField name={question.value}>
              {(field) => (
                <field.ToggleGroupSelect
                  label={question.label}
                  options={question.options}
                  required={true}
                  disabled={readonly}
                />
              )}
            </form.AppField>
          </Box>
        ))}
      </>
    );
  },
});

export default RatingsForm;
